"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OramaSearchNoDocs = OramaSearchNoDocs;
exports.OramaSearchWithDocs = OramaSearchWithDocs;
exports.default = OramaSearchWrapper;
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const router_1 = require("@docusaurus/router");
const client_1 = require("@docusaurus/plugin-content-docs/client");
const theme_common_1 = require("@docusaurus/theme-common");
const useGlobalData_1 = require("@docusaurus/useGlobalData");
const react_components_1 = require("@orama/react-components");
const useOrama_1 = require("./useOrama");
function OramaSearchNoDocs() {
    const { searchBoxConfig, searchBtnConfig: { text, ...searchBtnConfigRest }, colorMode } = (0, useOrama_1.useOrama)();
    return (react_1.default.createElement("div", null, searchBoxConfig.basic && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_components_1.OramaSearchButton, { colorScheme: colorMode, className: "DocSearch-Button", ...searchBtnConfigRest }, text || "Search"),
        react_1.default.createElement(react_components_1.OramaSearchBox, { ...searchBoxConfig.basic, ...searchBoxConfig.custom, colorScheme: colorMode, searchParams: {
                where: {
                    version: { eq: "current" }
                }
            } })))));
}
function OramaSearchWithDocs({ pluginId }) {
    const versions = (0, client_1.useVersions)(pluginId);
    const activeVersion = (0, client_1.useActiveVersion)(pluginId);
    const { preferredVersion } = (0, theme_common_1.useDocsPreferredVersion)(pluginId);
    const currentVersion = activeVersion || preferredVersion || versions[0];
    const { searchBoxConfig, searchBtnConfig: { text, ...searchBtnConfigRest }, colorMode } = (0, useOrama_1.useOrama)();
    const searchParams = {
        ...(currentVersion && {
            where: {
                version: { eq: currentVersion.name }
            }
        })
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_components_1.OramaSearchButton, { colorScheme: colorMode, className: "DocSearch-Button", ...searchBtnConfigRest }, text || "Search"),
        searchBoxConfig.basic && (react_1.default.createElement(react_components_1.OramaSearchBox, { ...searchBoxConfig.basic, ...searchBoxConfig.custom, colorScheme: colorMode, searchParams: searchParams }))));
}
function OramaSearchWrapper() {
    const { pathname } = (0, router_1.useLocation)();
    const { docsInstances } = (0, useGlobalData_1.usePluginData)("@orama/plugin-docusaurus-v3");
    const pluginId = docsInstances.filter((id) => pathname.includes(id))[0] || docsInstances[0];
    if (!pluginId) {
        return react_1.default.createElement(OramaSearchNoDocs, null);
    }
    return react_1.default.createElement(OramaSearchWithDocs, { pluginId: pluginId });
}
